module.exports = __webpack_public_path__ + "img/1.0cea58f9.png";